export default __webpack_public_path__ + "static/media/Cut.6d27cc53.svg";